import xgplayer from 'xgplayer'

class Sniffer {
  init () {
    var doc = document.documentElement
    doc.setAttribute('data-useragent', navigator.userAgent)
  }

  isPC () {
    return xgplayer.sniffer.os.isPc
  }

  isAndroid () {
    return xgplayer.sniffer.os.isAndroid
  }

  getPlatform () {
    return xgplayer.sniffer.os
  }
}

export default new Sniffer()
